import {Box, Button, Collapse, Fade, Zoom} from '@mui/material';
import React, {useEffect, useState} from 'react';
import {COLORS, Typography} from '@fupa/fupa-uikit';
import styled from 'styled-components';
import {TransitionGroup} from 'react-transition-group';

const COLORS_SECONDARY_30 = 'rgba(0, 150, 219, 0.3);';
const BUTTON_HEIGHT = 28;

const StyledTypography = styled(Typography)`
  &&& {
    padding-right: 0.25rem;
  }
`;

const AnimationContainer = styled('div')`
  position: absolute;
  top: 0;
  justify-self: end;
  display: flex;
  width: 0;
  height: 32px;
  overflow: hidden;
  border-radius: 4px;
  opacity: 0;
  transition: width 0.5s, opacity 0.5s;
  margin-top: 0.25rem;
  background-color: ${COLORS.white};
  ${props => props.in && `width: 100%; opacity: 1;`};
`;

const buttonSX = {
  backgroundColor: COLORS_SECONDARY_30,
  borderColor: COLORS.fupaSecondary,
  minWidth: '3.5rem',
  '&:hover': {
    backgroundColor: COLORS_SECONDARY_30,
    borderColor: COLORS.fupaSecondary,
  },
  '&:active': {
    backgroundColor: COLORS_SECONDARY_30,
    borderColor: COLORS.fupaSecondary,
  },
};

const buttonBasicSX = {
  textTransform: 'none',
  borderRadius: `${BUTTON_HEIGHT}px`,
  borderColor: COLORS.grey,
  fontSize: '1rem',
  height: `${BUTTON_HEIGHT}px`,
  minWidth: '6rem',
  '&:hover': {
    borderColor: COLORS.grey,
  },
};

const MatchTickerVotingButton = ({active, handleClick}) => {
  const [init, setInit] = useState(true);

  useEffect(() => {
    setInit(false);
  }, []);

  const initDelay = 0;
  const activeDelay = active ? 0 : 500;
  const transitionDelay = init ? initDelay : activeDelay;

  return (
    <Collapse in={!active} collapsedSize={BUTTON_HEIGHT}>
      <Button
        size='small'
        sx={active ? {...buttonBasicSX, ...buttonSX} : buttonBasicSX}
        variant={'outlined'}
        onClick={handleClick}>
        <TransitionGroup>
          <Box sx={{display: 'flex', height: `${BUTTON_HEIGHT}px`, justifyContent: 'center', alignItems: 'center'}}>
            <Collapse in={!active} orientation={'horizontal'} collapsedSize={0}>
              <Fade style={{transitionDelay: `${transitionDelay}ms`}} timeout={{enter: 0, exit: 0}} in={!active}>
                <div style={{display: 'flex'}}>
                  <StyledTypography variant={'caption1'}>Top-Ticker</StyledTypography>
                </div>
              </Fade>
            </Collapse>
            <span>👍</span>
          </Box>
        </TransitionGroup>
      </Button>
    </Collapse>
  );
};

const AnimatedThumbUp = styled('div')`
  height: 1px;
  width: 1px;
  position: absolute;
  transform: translateX(-50%);

  &:after {
    content: '';
    position: absolute;
    height: 85%;
    width: 85%;
    left: 50%;
    top: 50%;
    transform: translate3d(-50%, -50%, 0) rotateZ(-45deg);
  }

  bottom: ${props => props.bottom}px;
  left: ${props => props.left}%;
  animation: bubble-movement 1s infinite ease-in ${props => props.duration}s;

  @keyframes bubble-movement {
    0% {
      transform: translate3d(-50%, 0, 0);
      height: 1px;
      width: 1px;
    }
    100% {
      transform: translate3d(-50%, -32px, 0);
      height: 75px;
      width: 75px;
    }
  }
`;

const MatchTickerVotingOverlayAnimation = ({active, animate}) => {
  const icons = [];

  for (let i = 1; i <= 10; i++) {
    const bottom = Math.floor(Math.random() * 10) + 1;
    const left = Math.floor(Math.random() * 99) + 1;
    const duration = Math.floor(Math.random() * 300) * -0.01;
    icons.push(
      <AnimatedThumbUp duration={duration} bottom={bottom} left={left} key={i}>
        👍
      </AnimatedThumbUp>
    );
  }

  return (
    <Box sx={{position: 'relative', width: '100%', display: 'flex', justifyContent: 'flex-end'}}>
      <AnimationContainer in={animate}>
        <Zoom in={animate} style={{transitionDelay: active ? '500ms' : '0ms'}}>
          <Box sx={{display: 'flex', flex: 100, justifyContent: 'center', alignItems: 'center'}}>
            <Typography variant={'button-sub'}>Top Liveticker!</Typography>
          </Box>
        </Zoom>
        {icons}
      </AnimationContainer>
    </Box>
  );
};

export {MatchTickerVotingButton, MatchTickerVotingOverlayAnimation};
